import { useDispatch, useSelector } from '@ecommerce/nest-ssr/common';
import { ReviewInterface } from 'modules/review/review.interface';
import { ProductReviewsActions } from '../reducers/product-reviews.reducer';
import { ApiListInterface } from 'interfaces/api.interface';
import { ReviewItemMessageInterface } from 'components/review/review.interface';

interface UseProductReviewsInterface {
    productReviews: ApiListInterface<ReviewInterface>;
    addComment: (params: { productReviewId: number; comment: ReviewItemMessageInterface; }) => void;
}

export const useProductReviews = (): UseProductReviewsInterface => {
    const dispatch = useDispatch();

    const productReviews = useSelector(
        (state: { productReviews: ApiListInterface<ReviewInterface>; }) => state.productReviews
    );

    const addComment = (params: { productReviewId: number; comment: ReviewItemMessageInterface; }): void => {
        dispatch({
            type: ProductReviewsActions.AddComment,
            payload: params
        });
    };

    return { productReviews, addComment };
};
